// extracted by mini-css-extract-plugin
module.exports = {"bottom":"bottom___1thfb","left":"left___3canU","right":"right___1ipa3"};